export const nameSpace = 'uploadDragger';
export const messagesNameSpace = 'uploadFiles.messages';
